export enum UserPlatformEnum {
    STORK = 'stork',
    SAAS = 'saas',
}
